var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpacer1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 1080 100",
    width: 1080,
    height: 100,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1080,
    height: 100,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 67L11.3 67C22.7 67 45.3 67 67.8 65.3C90.3 63.7 112.7 60.3 135.2 58.3C157.7 56.3 180.3 55.7 202.8 58.3C225.3 61 247.7 67 270.2 65.5C292.7 64 315.3 55 337.8 49.2C360.3 43.3 382.7 40.7 405.2 46.2C427.7 51.7 450.3 65.3 472.8 66.2C495.3 67 517.7 55 540.2 55.2C562.7 55.3 585.3 67.7 607.8 68.2C630.3 68.7 652.7 57.3 675.2 52.7C697.7 48 720.3 50 742.8 49.8C765.3 49.7 787.7 47.3 810.2 49.5C832.7 51.7 855.3 58.3 877.8 61.3C900.3 64.3 922.7 63.7 945.2 60.5C967.7 57.3 990.3 51.7 1012.8 48.7C1035.3 45.7 1057.7 45.3 1068.8 45.2L1080 45L1080 101L1068.8 101C1057.7 101 1035.3 101 1012.8 101C990.3 101 967.7 101 945.2 101C922.7 101 900.3 101 877.8 101C855.3 101 832.7 101 810.2 101C787.7 101 765.3 101 742.8 101C720.3 101 697.7 101 675.2 101C652.7 101 630.3 101 607.8 101C585.3 101 562.7 101 540.2 101C517.7 101 495.3 101 472.8 101C450.3 101 427.7 101 405.2 101C382.7 101 360.3 101 337.8 101C315.3 101 292.7 101 270.2 101C247.7 101 225.3 101 202.8 101C180.3 101 157.7 101 135.2 101C112.7 101 90.3 101 67.8 101C45.3 101 22.7 101 11.3 101L0 101Z",
    fill: "#f4940c",
    strokeLinecap: "round",
    strokeLinejoin: "miter"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpacer1);
export default __webpack_public_path__ + "static/media/spacer1.87d016d6e58876a79ef3872a4586ed5b.svg";
export { ForwardRef as ReactComponent };